import { render, staticRenderFns } from "./ReportesNomina.vue?vue&type=template&id=f5f4e95e&scoped=true"
import script from "./ReportesNomina.vue?vue&type=script&lang=js"
export * from "./ReportesNomina.vue?vue&type=script&lang=js"
import style0 from "./ReportesNomina.vue?vue&type=style&index=0&id=f5f4e95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f4e95e",
  null
  
)

export default component.exports